export default {
  'app.pwa.offline': 'You are currently offline',
  'app.pwa.serviceworker.updated': 'New content available',
  'app.pwa.serviceworker.updated.hint':
    'Please press the "Refresh" button to reload the current page',
  'app.pwa.serviceworker.updated.ok': 'Refresh',

  'app.pwa.install.title': 'Install AUTOMY',
  'app.pwa.install.prompt':
    'Open it as an app on this device and get alerts even when the browser is closed.',
  'app.pwa.install.button': 'Install',
  'app.pwa.install.ios.prompt': 'Install AUTOMY on your iPhone to get notifications',
  'app.pwa.install.ios.chrome.prompt': 'Install AUTOMY from Chrome to get notifications',
  'app.pwa.install.ios.button': 'How to install',
  'app.pwa.install.ios.step1': 'Tap the Share button',
  'app.pwa.install.ios.chrome.step1': 'Tap Share at the top right',
  'app.pwa.install.ios.step2': 'Choose Add to Home Screen',
  'app.pwa.install.ios.step3': 'Open AUTOMY from the new icon and sign in',
  'app.pwa.install.close': 'Close',

  'app.pwa.offlineBanner.title': 'You are offline',
  'app.pwa.offlineBanner': 'Open forms are saved on this device and sent when you reconnect.',

  'app.pwa.push.kicker': 'This device',
  'app.pwa.push.ask.title': 'Turn on notifications',
  'app.pwa.push.ask.message':
    'We will tell you about assigned tasks, comments and finished exports, even when AUTOMY is closed.',
  'app.pwa.push.ask.allow': 'Turn on',
  'app.pwa.push.ask.later': 'Not now',
  'app.pwa.push.description':
    'Get assigned tasks, comments and finished exports on this device, even when AUTOMY is closed.',
  'app.pwa.push.explain':
    'The switch applies only to this device. We notify you when a task is assigned to you, when there is a comment, and when an export is ready.',
  'app.pwa.push.toggle': 'Notifications on this device',
  'app.pwa.push.status.on': 'On for this device.',
  'app.pwa.push.status.off': 'Off for this device.',
  'app.pwa.push.status.unsupported': 'This browser does not support system notifications.',
  'app.pwa.push.status.iosNeedsInstall':
    'On iPhone and iPad, install AUTOMY first: Share, Add to Home Screen, then open it from the icon.',
  'app.pwa.push.status.denied':
    'Notifications are blocked. Allow them in your browser site settings and try again.',
  'app.pwa.push.status.unavailable': 'Device notifications are not available yet.',
  'app.pwa.push.error': 'Could not change notifications. Please try again.',
};
